import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HelpersService } from '../../../core/services/helpers.service';
import { OperationsService } from '../../../core/services/operations.service';
import { TitoloEsecutivoAdapter } from '../../components/fascicolo/titoli-update/titolo-esecutivo-adapter';
import { SottoTipoTitoloEsecutivo } from '../../models/tipologiche/sotto-tipo-titolo-esecutivo';
import { TipoTitoloEsecutivo } from '../../models/tipologiche/tipo-titolo-esecutivo';
import { TitoloEsecutivo } from '../../models/titolo-esecutivo';
import { FormValidationService } from '../../services/form-validation.service';
import { BaseForm } from '../base-Form';

declare var removeEmptyObject: any;


export abstract class TitoliFormComponent extends BaseForm {

  request: TitoloEsecutivo;
  titoloForm: FormGroup;

  tipiTitolo: TipoTitoloEsecutivo[] = [];
  sottoTipiTitolo: SottoTipoTitoloEsecutivo[] =[];


  constructor(protected operationService: OperationsService, private campiForm: FormBuilder, private helpers: HelpersService,
          private formValidationService: FormValidationService) {
    super();
  }

  createForm() {
    this.request = new TitoloEsecutivoAdapter(this.getTitolo()).titoloEsecutivo;
    this.titoloForm = this.campiForm.group({
      tipoTitoloEsecutivo: [this.request.tipoTitoloEsecutivo, Validators.required],
      sottoTipoTitoloEsecutivo: [this.request.sottoTipoTitoloEsecutivo, Validators.required],
      descrizione: [this.request.descrizione, Validators.required],
      numero: [this.request.numero],
      anno: [this.request.anno, Validators.compose([this.formValidationService.anno])],
      dataIscrizione: [this.request.dataIscrizione],
      valore: [this.request.valore],
      note: [this.request.note],
    });
  }

  update() {
    this.getRequest(this.request);
  }

  onChangeTipoTitolo(event) {
    const selectedTipo = this.tipiTitolo.find(el => el.id === event.target.value.trim());
    if (selectedTipo) {
      this.request.tipoTitoloEsecutivo = selectedTipo;
      this.loadSottoTipiByTipo(selectedTipo.id);
    } else {
      this.request.tipoTitoloEsecutivo = null;
      this.sottoTipiTitolo = [];
    }
  }
  
  onChangeSottoTipoTitoloEsecutivo(event) {
    const selectedSottoTipo = this.sottoTipiTitolo.find(el => el.id === event.target.value.trim());
    if (selectedSottoTipo) {
      this.request.sottoTipoTitoloEsecutivo = selectedSottoTipo;
    } else {
      this.request.sottoTipoTitoloEsecutivo = null;
    }
  }

  loadSottoTipiByTipo(tipoId: string) {
  this.helpers.getSottoTipoTitoloByTipoTitolo(tipoId).subscribe(response => {
    this.sottoTipiTitolo = response;
    });
  }
  
  populateSelect() {
    if(this.tipiTitolo.length === 0){
      this.helpers.getTipoTitolo().subscribe(response => this.tipiTitolo = response);
    }
    if(this.sottoTipiTitolo.length === 0){
      if (this.request && this.request.tipoTitoloEsecutivo) {
        this.loadSottoTipiByTipo(this.request.tipoTitoloEsecutivo.id)      
      }else{
        this.sottoTipiTitolo = [];
      }
   }
  }

  abstract getTitolo(): TitoloEsecutivo;
  abstract getRequest(request: TitoloEsecutivo);
}
